const _EDIT = "edit";
const _CREATE = "create";

const adDetailModes = Object.freeze({
  EDIT: _EDIT,
  CREATE: _CREATE,
});

export default adDetailModes;
